module.exports = __webpack_public_path__ + "img/ossetia.6fb316a9.svg";